import React from "react";
import { useHtml, useSetHtml } from "../../globals/HtmlContext.js";
import { useUser, useSetUser } from "../../globals/UserContext";
import { useQuestion } from "../../globals/QuestionContext";
import { useAssignment } from "../../globals/AssignmentContext";
import { saveAnswerAction } from "../../actions/saveAnswer.js";
import { levenshteinGrade } from "../../utils/levenshteinGrade";
import { checklistGrade } from "../../utils/checklistGrade";
import { html as htmlLang } from "@codemirror/lang-html";
import CodeMirror from "@uiw/react-codemirror";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import "./index.css";

//docs for CodeMirror: https://uiwjs.github.io/react-codemirror

export default function Editor() {
  const html = useHtml();
  const user = useUser();
  const setUser = useSetUser();
  const assignment = useAssignment();
  const setHtml = useSetHtml();
  const question = useQuestion();
  let answer = question?.answer;

  // this is the number of milliseconds it waits for users to stop typing
  const waitingTime = 750;

  const [tempHtml, setTempHtml] = React.useState(html);

  // this gets called whenever html is updated, and cleans up by restarting the timer and calling timeout (I think)
  // so timeout doesn't need to get called anywhere else
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setHtml(tempHtml);
      handleSave(tempHtml);
    }, waitingTime);

    return () => clearTimeout(timeout);
  }, [tempHtml]);

  const handleChange = (value, viewUpdate) => {
    setTempHtml(value);
  };

  const handleSave = (newHtml) => {
    if (question.grading_type === "checklist") {
      const testResults = checklistGrade(question.checklist);
      let correct = 0;
      for (let corr of testResults) {
        if (corr) {
          correct++;
        }
      }
      const grade = correct / question.checklist.length;
      saveAnswerAction(
        user._id,
        assignment._id,
        question._id,
        grade,
        newHtml,
        setUser,
        testResults
      );
    } else if (question.grading_type === "levenshtein") {
      const grade = levenshteinGrade(question.code, answer, newHtml);
      saveAnswerAction(
        user._id,
        assignment._id,
        question._id,
        grade,
        newHtml,
        setUser,
        []
      );
    } else {
      if (answer?.replace(/\s/g, "") === newHtml.replace(/\s/g, "")) {
        saveAnswerAction(
          user._id,
          assignment._id,
          question._id,
          1,
          newHtml,
          setUser,
          []
        );
      } else {
        saveAnswerAction(
          user._id,
          assignment._id,
          question._id,
          0,
          newHtml,
          setUser,
          []
        );
      }
    }
  };

  return (
    <div className="editor-container">
      <div className="editor-title">HTML</div>
      <CodeMirror
        onChange={handleChange}
        value={html}
        className="codemirror-wrapper"
        theme={okaidia}
        height="100%"
        maxWidth="100%"
        extensions={[
          htmlLang({ matchClosingTags: false, autoCloseTags: false }),
        ]}
      />
    </div>
  );
}
